import React, { useEffect, useState } from 'react'

import { Button, Tooltip, Table, Tabs } from 'antd'

import { GiHockey } from 'react-icons/gi'
import { useDispatch, useSelector } from 'react-redux'

import { auctionEnded, getAuctionPlayer, markAsPaid } from '../redux/actions/rosterAction'
import { getAge } from '../config/helperFunctions'
import moment from 'moment'

// Component
import MainHeader from '../components/MainHeader'
import PlayerDetailsModal from '../components/modal/PlayerDetailsModal'
import { openModal } from '../redux/actions/interfaceModalActions'

const PlayerAuction = () => {
  const { data } = useSelector((state) => state.auction)
  const [isLoading, setIsLoading] = useState(false)
  const [tab, setTab] = useState(1)

  const dispatch = useDispatch()

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    setIsLoading(true)
    const res = await getAuctionPlayer()
    setIsLoading(false)
  }

  const columns = [
    {
      title: ' ',
      dataIndex: 'HostedHeadshotNoBackgroundUrl',
      key: 'HostedHeadshotNoBackgroundUrl',
      render: (_, obj) => {
        return (
          <div className='squad_image_box'>
            {obj?.player_id?.HostedHeadshotNoBackgroundUrl ? (
              <img src={obj?.player_id?.HostedHeadshotNoBackgroundUrl} alt={'Player'} />
            ) : (
              <GiHockey size={45} color={'#c4c4c4'} />
            )}
          </div>
        )
      },
    },
    {
      title: 'POSITION',
      dataIndex: 'Position',
      key: 'Position',
      render: (_, obj) => <p>{obj?.player_id?.Position || '-'}</p>,
    },
    {
      title: 'PLAYER NAME',
      dataIndex: 'Name',
      key: 'Name',
      render: (_, obj) => {
        return (
          <>
            <span
              className='fa_p_name name_text_hover'
              onClick={() => {
                dispatch(
                  openModal({
                    playerID: null,
                    isReserve: false,
                    teamId: null,
                    teamName: '',
                    teamLogo: null,
                    auction: {
                      isAuction: true,
                      auctionId: obj?._id,
                      hasAuctionEnded: obj?.hasAuctionEnded,
                    },
                  }),
                )
              }}
            >
              {obj?.player_id?.Name}
            </span>{' '}
            {obj?.module === 'waiver' && <span className='waiver_tag'>Waiver</span>}
          </>
        )
      },
    },
    {
      title: 'AGE',
      dataIndex: 'BirthDate',
      key: 'BirthDate',
      render: (_, obj) => <p>{obj?.player_id?.Age || getAge(obj?.player_id?.BirthDate) || '-'}</p>,
    },
    {
      title: 'TEAM',
      dataIndex: 'Team',
      key: 'Team',
      render: (_, obj) => <p>{obj?.player_id?.Team || '-'}</p>,
    },
    {
      title: 'OPP',
      dataIndex: 'Opponent',
      key: 'Opponent',
      render: (_, obj) => <p>{obj?.player_id?.Opponent || '-'}</p>,
    },
    {
      title: 'BYE',
      dataIndex: 'ByeWeek',
      key: 'ByeWeek',
      render: (_, obj) => <p>{obj?.player_id?.ByeWeek || '-'}</p>,
    },
    {
      title: 'PLAYER CAP #',
      dataIndex: 'PlayerCap',
      key: 'PlayerCap',
      render: (_, obj) => (
        <p>
          {' '}
          {obj?.player_id?.PlayerCap ? `$${obj?.player_id?.PlayerCap?.toLocaleString()}` : '-'}
        </p>
      ),
    },
    {
      title: 'CURRENT BID',
      dataIndex: 'highestCurrentBid',
      key: 'highestCurrentBid',
      render: (t) => <p>{t ? `$${t?.toLocaleString()}` : '-'}</p>,
    },
    {
      title: 'TIME LEFT',
      dataIndex: 'hasAuctionStarted',
      key: 'hasAuctionStarted',
      render: (_, obj) => <AuctionTimer data={obj} getData={getData} />,
    },
  ]

  const columnWithPayButton = [
    ...columns,
    {
      title: ' ',
      dataIndex: 'isPaid',
      key: 'isPaid',
      render: (_, obj) => <PayButton data={obj} getData={getData} />,
    },
  ]

  const items = [
    {
      key: '1',
      label: 'Live Auction',
      children: (
        <div className='new_table_container auction_table_container'>
          <Table
            loading={isLoading}
            dataSource={data?.liveAuctions}
            columns={columns}
            bordered={false}
            pagination={false}
            scroll={{ x: 1100 }}
            className='all_auction_table'
            rowKey='_id'
          />
        </div>
      ),
    },
    {
      key: '2',
      label: 'Past Auction',
      children: (
        <div className='new_table_container auction_table_container'>
          <Table
            loading={isLoading}
            dataSource={data?.pastAuctions}
            columns={columns}
            bordered={false}
            pagination={false}
            scroll={{ x: 1100 }}
            className='all_auction_table'
            rowKey='_id'
          />
        </div>
      ),
    },
  ]

  return (
    <div className='practice_squad_container team_trade_main'>
      <MainHeader headingAndDate={false} />

      <div className='header' style={{ marginBlock: '20px' }}>
        <h2>AUCTIONS</h2>
      </div>

      <Tabs size='large' defaultActiveKey='1' items={items} onChange={(key) => setTab(key)} />

      <div className='header' style={{ marginBlock: '20px' }}>
        <h2>MY AUCTION</h2>
      </div>

      <div className='new_table_container'>
        <Table
          loading={isLoading}
          dataSource={data?.myAuctions}
          columns={columnWithPayButton}
          bordered={false}
          pagination={false}
          scroll={{ x: 1100 }}
          className='my_auction_table'
          rowKey='_id'
        />
      </div>

      <PlayerDetailsModal />
    </div>
  )
}

const AuctionTimer = ({ data: v, getData }) => {
  const [remainingTime, setRemainingTime] = useState('')

  const ended = async () => {
    const res = await auctionEnded({ auctionId: v?._id })
    if (res) {
      await getData()
    }
  }

  useEffect(() => {
    let interval
    if (!v?.hasAuctionEnded) {
      interval = setInterval(() => {
        const now = moment()
        const end = moment(v?.endDate)
        const duration = moment.duration(end.diff(now))
        if (duration.asSeconds() <= 0) {
          clearInterval(interval)
          setRemainingTime('Auction Ended!')
          ended()
        } else {
          const days = Math.floor(duration.asDays())
          const hours = String(duration.hours()).padStart(2, '0')
          const minutes = String(duration.minutes()).padStart(2, '0')
          const seconds = String(duration.seconds()).padStart(2, '0')
          setRemainingTime(
            days === 0
              ? `${hours}h ${minutes}m ${seconds}s`
              : `${days}d ${hours}h ${minutes}m ${seconds}s`,
          )
        }
      }, 1000)
    } else {
      setRemainingTime('Auction Ended!')
    }

    return () => {
      clearInterval(interval)
    }
  }, [v?.endDate])

  return (
    <>
      {v?.hasAuctionStarted ? (
        <div style={{ minWidth: '130px' }}>
          <p
            style={{ textTransform: remainingTime === 'Auction Ended!' ? 'initial' : 'lowercase' }}
          >
            {remainingTime || '-'}
          </p>
        </div>
      ) : (
        <div style={{ minWidth: '130px' }}>
          <p style={{ textTransform: 'lowercase' }}>
            Auction will start on {moment(v?.startDate).format('YYYY-MM-DD hh:mm a')}
          </p>
        </div>
      )}
    </>
  )
}

const PayButton = ({ data: v, getData }) => {
  const USER = useSelector((state) => state?.user?.userDetails)
  const [loadingId, setLoadingId] = useState('')

  const pay = async (id) => {
    setLoadingId(id)
    const res = await markAsPaid({ auctionId: id })
    if (res) {
      setLoadingId('')
      getData()
    }
  }

  const isVisible = () => v?.assigned?.user === USER?._id
  //  &&
  // v?.auctionStartedBy?.team !== v?.assigned?.team &&
  // v?.auctionFrom === 'nonowner'

  return (
    <>
      {isVisible() && (
        <Tooltip
          placement='top'
          title={
            v?.isPaid ? (
              <>
                <p>
                  The Auction has been mark as paid, the player will be transferred after admin
                  approval, and if the player is locked then the player will come up in the next
                  week roster
                </p>
              </>
            ) : (
              <>
                <p>Pay Before:</p>
                <p style={{ fontWeight: 700 }}>{`${moment(v?.payBefore).format(
                  'ddd, YYYY-MM-DD hh:mm a',
                )}`}</p>
                <p>
                  to add this player to your active roster in the upcoming week otherwise the
                  auction will be cancelled.
                </p>
              </>
            )
          }
        >
          <Button
            disabled={v?.isPaid}
            loading={loadingId === v?._id}
            onClick={() => pay(v?._id)}
            type='primary'
          >
            {v?.isPaid ? 'PAID' : 'PAY'}
          </Button>
        </Tooltip>
      )}
    </>
  )
}

export default PlayerAuction
